import gql from 'graphql-tag'

export default gql`
  fragment operatorShiftInformation on Shift {
    _id
    startedAt
    endedAt
    vehicleType
    deactivatedUntil
    reservedShift {
      _id
      name
    }
    activeOrders {
      _id
      code
      description
    }
    vehicle {
      _id
      type
      code
      completedOrdersCount
      firstName
      lastName
      categoryId
      approvedAt
    }
    location {
      speed
      date
    }
  }
`
